import { PureComponent, ReactElement, ReactNode } from 'react';
import track from 'react-tracking';
import { SWS_IMAGES } from '@/constants';
import { SnowflakeHelp } from '@components/Help';
import ChartWrapper from '@/pages/CompanyReport/components/Overview/components/ChartWrapper';

interface SnowflakeChartWrapperProps {
  id?: string;
  points: number[];
  feedbackLabel?: string;
  companyForFeedback?: string;
  chart?: ReactElement;
  table?: ReactNode;
  preRenderHeight?: string | number;
  preRenderHeightSmDown?: string | number;
}

@track({
  type: 'track',
  subject: 'chart',
  title: 'snowflake',
})
class SnowflakeChartWrapper extends PureComponent<SnowflakeChartWrapperProps> {
  getExportUrl = (theme: string) => {
    const { points } = this.props;

    const valuationScore = points && points.length > 0 ? points[0] : 0;
    const futureScore = points && points.length > 1 ? points[1] : 0;
    const pastScore = points && points.length > 2 ? points[2] : 0;
    const financialScore = points && points.length > 3 ? points[3] : 0;
    const dividendScore = points && points.length > 4 ? points[4] : 0;

    const snowflakeTheme = theme === 'light' ? 'light' : 'dark';
    return `${SWS_IMAGES}/snowflake/?points[]=${valuationScore}&points[]=${futureScore}&points[]=${pastScore}&points[]=${financialScore}&points[]=${dividendScore}&theme=${snowflakeTheme}&size=small`;
  };

  render() {
    const { getExportUrl } = this;

    const {
      id,
      feedbackLabel,
      companyForFeedback,
      chart,
      table,
      preRenderHeight = 338,
      preRenderHeightSmDown = 268,
    } = this.props;

    const darkUrl = getExportUrl('dark');
    const lightUrl = getExportUrl('light');

    return (
      <ChartWrapper
        chart={chart}
        table={table}
        id={id || ''}
        helpTitle={'About the Snowflake'}
        help={<SnowflakeHelp />}
        exportDarkUrl={darkUrl}
        exportLightUrl={lightUrl}
        feedbackLabel={feedbackLabel}
        companyName={companyForFeedback as string}
        keepChartRendered={false}
        actionsMarginTop={8}
        preRenderHeight={preRenderHeight}
        preRenderHeightSmDown={preRenderHeightSmDown}
        blurIfUnauthenticated={false}
      />
    );
  }
}

export default SnowflakeChartWrapper;
